export const MARKET_URL_KEY = "MarketUrl";
export const GET_LOCATION_BY_IP_URL = "https://des-get-ip.jtides.com/";
